import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { User } from '../../types/user.model';
import { INTRODUCE_YOURSELF_EDIT_MODE } from '../add-profile-pic-modal/add-profile-pic-modal.component';

@Component({
  selector: 'mmb-web-app-add-date-of-birth-modal',
  templateUrl: './add-date-of-birth-modal.component.html',
  styleUrls: ['./add-date-of-birth-modal.component.scss']
})
export class AddDateOfBirthModalComponent implements OnInit {
  @Output() addSuccess: EventEmitter<any> = new EventEmitter<any>();
  @Output() closed: EventEmitter<any> = new EventEmitter<any>();
  @Input() user: User;
  form: UntypedFormGroup;
  INTRODUCE_YOURSELF_EDIT_MODE = INTRODUCE_YOURSELF_EDIT_MODE;

  constructor(private fb: UntypedFormBuilder) { }

  ngOnInit() {
    this.form = this.fb.group({
      name: [this.user.credentials ? this.user.first_name : ''],
      gender: [this.user.gender ? this.user.gender : ''],
      dob: [this.user.birth_date ? this.user.birth_date : '', Validators.required],
      country_signup: [this.user.country_signup ? this.user.country_signup : ''],
      city_signup: [this.user.city_signup ? this.user.city_signup : this.user.city_custom_signup],
    });
  }

  onClose() {
    this.closed.emit();
  }

}
